<template>
  <header class="container py-5">
    <div class="d-flex justify-content-between align-items-center">
      <router-link :to="{name: 'home'}" class="my-0">
        <Logo />
      </router-link>
      <div class="d-flex align-items-center">
        <ModeSwitcher/>
        <div v-if="languages.length > 1">
          <a href="#" class="text-decoration-none text-uppercase text-dark ml-2" v-on:click.prevent="isShowModal = true"><b>{{selectedLanguage}}</b></a>
          <Modal
            :isShow="isShowModal"
            :isShowFooter="false"
            size="sm"
            v-on:close="isShowModal = false"
          >
            <div class="p-3">
              <a href="#"
                class="bg-hover text-decoration-none text-dark d-flex align-items-center"
                :class="[{'bg-hover--active': language === selectedLanguage}, {'mb-1': index + 1 < languages.length}]"
                v-for="(language, index) in languages"
                :key="`language-${language}`"
                v-on:click.prevent="setLanguage(language)"
              >
                <span class="d-block">{{ $t(`languages.${language}`) }}</span>
              </a>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { BASE_LANGUAGE } from '../constants'
import Logo from './elements/Logo'
import ModeSwitcher from './elements/ModeSwitcher.vue'

export default {
  data() {
    return {
      isShowModal: false,
      selectedLanguage: BASE_LANGUAGE,
      languages: Object.keys(this.$i18n.messages)
    }
  },
  components: {
    Logo,
    ModeSwitcher
  },
  beforeMount() {
    const routeLang = this.$route.params.lang

    if (routeLang) {
      this.$i18n.locale = routeLang.toLowerCase()
    }
    this.selectedLanguage = this.$i18n.locale
  },
  methods: {
    setLanguage(lang) {
      const routeQuery = this.$route.query

      this.$router.push({ params: { lang }, query: routeQuery })
      this.$i18n.locale = lang
      this.selectedLanguage = lang
      this.isShowModal = false
    }
  }
}
</script>

<style lang="scss">
@import "../style/variables";

.flag-icon{
  width: 2rem;
  height: 2rem;
}
.bg-hover{
  border-radius: $border-radius;
  padding: 0.5rem;
  cursor: pointer;
  &:hover, &--active{
    background-color: $gray-200;
  }
}
.language-select{
  max-width: 60px;
}
</style>
